import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';
import { invalid } from 'moment';
@Directive({
  standalone: false,
  selector: '[NoWhitespace]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: NoWhitespaceDirective, multi: true },
  ],
})
export class NoWhitespaceDirective  implements Validator{

  constructor() { }

  validate(control: AbstractControl) {
    if (!control.value || control.value.trim() == '') {
       control.setErrors({'status':invalid});
      return { required: true };
    }

    if(control.value){
      control.value.trim();
    }
    
    return null;
  }

}
